import React, { Component } from 'react';
import { graphql, createFragmentContainer } from 'react-relay';
import { Link } from 'react-router-dom';

import { StoreProvider } from '../../components';
import { AdminCell } from '../Admins';

export class AdminListView extends Component {
  render() {
    const { lists } = this.props;
    const admins = lists.adminUsers.edges.map((e) => e.node);

    return (
      <div className="admins">
        <div className="header">
          <h2>Admins</h2>
          <div className="actions">
            <Link to="/admins/new" className="button">
              Add Admin
            </Link>
          </div>
        </div>
        <table className="tables">
          <thead>
            <tr>
              <th>Email</th>
            </tr>
          </thead>
          <tbody>
            {admins.map((admin) => (
              <AdminCell key={admin.id} lists={lists} user={admin} />
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

const Container = createFragmentContainer(AdminListView, {
  lists: graphql`
    fragment AdminList_lists on Lists {
      ...AdminCell_lists
      adminUsers(first: 1000) @connection(key: "AdminList_adminUsers") {
        edges {
          node {
            id
            ...AdminCell_user
          }
        }
      }
    }
  `,
});

export default class AdminList extends Component {
  render() {
    return (
      <StoreProvider
        modern
        container={Container}
        query={graphql`
          query AdminListQuery {
            lists {
              ...AdminList_lists
            }
          }
        `}
      />
    );
  }
}
